<template>
    <div class="schedule-calendar">
        <div class="card">
            <div class="card-body p-0">
                <div v-if="currentSchedule" class="current-event">
                    <h3 class="mb-0" v-text="currentSchedule.course.title"></h3>
                    <div class="date mb-1" v-text="`${shortDateTime(currentSchedule.date)} at ${currentSchedule.location}`"></div>
                    <div class="instructor">
                        <strong>Instructor: </strong><span v-text="currentSchedule.instructor.name"></span>
                    </div>

                    <button type="button" class="close" @click="currentSchedule = null">
                        <span aria-hidden="true">&times;</span>
                    </button>

                    <button type="button" class="btn btn-nlcaa" @click="redirectTo(`/courses/${currentSchedule.course.slug}`)">
                        Sign Up Now
                    </button>
                </div>
                <div class="schedule-calendar-container" id="schedule-calendar"></div>
            </div>
        </div>
    </div>
</template>
<script>

    let ScheduleCalendar = require('@/mixins/ScheduleCalendar');

    export default {

        mixins: [ScheduleCalendar],

        data() {
            return {
                currentSchedule: false,
            }
        },

        methods: {

            fetchSchedules(dates, callback) {
                App.request().get(`/api/schedule`, {
                    params: {
                        publish: true,
                        from: moment(dates.startStr).subtract(1, 'week').format(),
                        to: moment(dates.endStr).add(1, 'week').format(),
                    }
                }).then(response => {
                    this.events = this.mapSchedules(response.data).concat(this.holidays)
                    callback(this.events);
                })
            },

            onEventClick(event, jsEvent, view) {
                this.currentSchedule = event.extendedProps.schedule;
            },
        },
    }
</script>